import { createFileRoute, Outlet } from '@tanstack/react-router';
import { MewsTeam, RouteType } from '@mews/enums';

export const Route = createFileRoute('/_public/Home')({
    component: () => <Outlet />,
    staticData: {
        owner: MewsTeam.Productivity,
        type: RouteType.Frontend,
        excludeBreadcrumb: true,
    },
});
